import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CampaignsAPI from 'dashboard/api/campaigns';
import { useAlert } from 'dashboard/composables';

export const useCampaignReport = () => {
  const reportCampaignId = ref(null);
  const reportResponse = ref(null);
  const isLoadingReport = ref(false);
  const { t } = useI18n();

  const resetReport = () => {
    reportCampaignId.value = null;
    reportResponse.value = null;
  };

  const loadReport = async campaignId => {
    if (!campaignId) return;

    if (reportCampaignId.value === campaignId) {
      resetReport();
      return;
    }

    reportCampaignId.value = campaignId;
    isLoadingReport.value = true;
    try {
      const { data } = await CampaignsAPI.show(campaignId);
      reportResponse.value = data;
    } catch (error) {
      const message =
        error?.response?.data?.message || t('CAMPAIGN.REPORT.ERROR_MESSAGE');
      useAlert(message);
      resetReport();
    } finally {
      isLoadingReport.value = false;
    }
  };

  const reportData = computed(() => reportResponse.value?.report || null);

  return {
    reportCampaignId,
    reportResponse,
    reportData,
    isLoadingReport,
    loadReport,
    resetReport,
  };
};

export default useCampaignReport;
